import { Typography } from "@mui/material";

export const TextSubtitle = ({ ...props }) => (
  <Typography variant="subtitle2" py={0.5} px={1.5} {...props} />
);
